import { usePlatform } from '@/hooks/usePlatform'

/** @deprecated Use usePlatform */
export const useProtocol = usePlatform
